import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, role }) {
    const { user, loading } = useAuth();
    if (loading) return <div className="min-h-screen grid place-items-center text-stone-500 text-sm">Loading...</div>;
    if (!user) return <Navigate to="/login" replace />;
    if (role) {
        const allowed = Array.isArray(role) ? role : [role];
        if (!allowed.includes(user.role)) return <Navigate to="/" replace />;
    }
    return children;
}
